import PropTypes from 'prop-types';
import React from 'react';
import { Percentage } from '~/modules/common/components';
import useStyles from './useStyles';

export const PercentageFormatter = ({ field, record }) => {
  const { isActive } = record;
  const percentage = record[field];
  const classes = useStyles({ isActive });

  return (
    <div className={classes.root}>
      <Percentage value={percentage || 0} />
    </div>
  );
};

PercentageFormatter.propTypes = {
  field: PropTypes.string,
  record: PropTypes.object
};

export default PercentageFormatter;
